<template>
    <div class="card">
        <div class="card-header">
            <div class="d-flex align-items-center">
                <div class="m-r-10">
                    <span class="display-5">
                        <img src="../../../../assets/images/audits/global-gap.png" style="width: 150px;">
                    </span>
                </div>
                <div class="m-r-40">
                    <div><h4>Global GAP Audit Report</h4></div>
                    <template v-if="auditReport.audited_by">
                        <div>{{auditReport.audited_by.firm.name}}</div>
                        <span class="text-muted">Auditor</span>
                    </template>
                    <div>
                        <a v-if="auditReport.borlaug" target="_blank" v-bind:href="this.$BORLAUG + '/address/' + auditReport.borlaug.address">{{auditReport.borlaug.address}}</a>
                    </div>
                    <span class="text-muted">Contract Address</span>
                </div>
            </div>
        </div>
        <hr/>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <v-chart :options="options" auto-resize ref="map"/>
                </div>
            </div>
            <div class="row m-t-40">
                <div class="col-4">
                    <div class="row">
                        <div class="col-lg-12 m-t-40 m-l-10" v-if="auditReport.summary && auditReport.summary.consolidated">
                            <div class="d-flex align-items-center">
                                <div class="icon">
                                    <span class="display-6">
                                        <i class="fas fa-globe"></i>
                                    </span>
                                </div>
                                <div>
                                    <h3 class="font-medium m-b-0">{{auditReport.summary.consolidated.yesCount}} / {{auditReport.summary.consolidated.totalCount}}</h3>
                                    <span>Complies / Total</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-8">
                    <div class="row">
                        <div class="col-lg-6 m-b-25" v-if="auditReport.summary && auditReport.summary.AF">
                            <div class="d-flex align-items-center">
                                <div class="icon m-r-10">
                                    <span class="display-6">
                                        <i class="fas fa-tractor"></i>
                                    </span>
                                </div>
                                <div>
                                    <h3 class="font-medium m-b-0">{{ auditReport.summary.AF.yesCount * 100 / auditReport.summary.AF.totalCount | percentage(2)}}</h3>
                                    <span>All Farm Base</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 m-b-25" v-if="auditReport.summary && auditReport.summary.CB">
                            <div class="d-flex align-items-center">
                                <div class="icon m-r-10">
                                    <span class="display-6">
                                        <i class="fas fa-tree"></i>
                                    </span>
                                </div>
                                <div>
                                    <h3 class="font-medium m-b-0">{{ auditReport.summary.CB.yesCount * 100 / auditReport.summary.CB.totalCount | percentage(2)}}</h3>
                                    <span>Crops Base</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 m-b-25" v-if="auditReport.summary && auditReport.summary.FV">
                            <div class="d-flex align-items-center">
                                <div class="icon m-r-10">
                                    <span class="display-6">
                                        <i class="fas fa-carrot"></i>
                                    </span>
                                </div>
                                <div>
                                    <h3 class="font-medium m-b-0">{{ auditReport.summary.FV.yesCount * 100 / auditReport.summary.FV.totalCount | percentage(2)}}</h3>
                                    <span>Fruits &amp; Vegetables</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 m-b-25" v-if="auditReport.summary && auditReport.summary.CUSTOM">
                            <div class="d-flex align-items-center">
                                <div class="icon m-r-10">
                                    <span class="display-6">
                                        <i class="fab fa-whmcs"></i>
                                    </span>
                                </div>
                                <div>
                                    <h3 class="font-medium m-b-0">
                                        {{ auditReport.summary.CUSTOM.yesCount * 100 / (auditReport.summary.CUSTOM.totalCount==0?1:auditReport.summary.CUSTOM.totalCount) | percentage(2)}}</h3>
                                    <span>Custom</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer text-muted">
            Audits provided by <a href="https://www.truvito.io" target="_blank">TruVito<sup>&trade;</sup></a>
        </div>
    </div>
</template>

<script>
    import ECharts from 'vue-echarts/components/ECharts';
    import 'echarts/lib/chart/pie';
    import 'echarts/lib/component/legend';
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/title';

    export default {
        name: "GlobalGapReport",
        props: ["audit"],
        components: {
            'v-chart': ECharts
        },
        watch: {
            audit: function(newVal, oldVal) {
                if(this.audit.id) {
                    this.getAuditReport();
                }
            }
        },
        data() {
            return {
                options: {
                    title: {
                        text: 'Global Gap Summary',
                        x: 'left',
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'left',
                        data: [],
                        top: '50px',
                    },
                    series: [
                        {
                            name: 'Audit',
                            type: 'pie',
                            label: {
                                normal: {
                                    position: 'center',
                                    color: '#fff'
                                }
                            },
                            radius: [0, '20%'],
                            center: ['60%', '60%'],
                            data: []
                        },
                        {
                            name: 'Module',
                            type: 'pie',
                            label: {
                                normal: {
                                    position: 'inner'
                                }
                            },
                            radius: ['35%', '60%'],
                            center: ['60%', '60%'],
                            data: []
                        },
                        {
                            name: 'Compliance',
                            type: 'pie',
                            radius: ['70%', '80%'],
                            center: ['60%', '60%'],
                            data: []
                        }
                    ]
                },
                auditReport: {
                    audited_by: {
                        auditor: {
                            address: null,
                            biz_address: null
                        },
                        firm: {
                            address: null,
                            biz_address: null
                        }
                    },
                    borlaug: {
                        address: null,
                        tx: null
                    },
                    coop: {
                        address: null,
                        biz_address: null,
                        org_props: null
                    },
                    created_by: {
                        address: null
                    },
                    id: null,
                    created_on: null,
                    report: null,
                    status: null,
                    title: null,
                    type: null,
                    summary: null
                }
            }
        },
        mounted() {
            this.getAuditReport();
        },
        methods: {
            async getAuditReport() {
                let reply        = await this.$http.get(`/integrations/audits/${this.audit.id}`);
                this.auditReport = reply.data;
                this.setChartData(this.auditReport.summary);

            },
            setChartData(summary) {
                let data         = ['Global GAP'];
                let parentData   = [{value: summary.consolidated.totalCount, name: 'Global GAP'}];
                let childData    = [];
                let subChildData = [];
                if(summary.AF) {
                    data.push('All Farm Base');
                    childData.push({value: summary.AF.totalCount, name: 'All Farm Base'});
                    let yes = summary.AF.yesCount;
                    subChildData.push({value: summary.AF.yesCount, name: 'AF Yes'});
                    subChildData.push({value: summary.AF.noCount, name: 'AF No'});
                    subChildData.push({value: summary.AF.naCount, name: 'AF N/A'});
                    subChildData.push({value: summary.AF.totalCount - (summary.AF.yesCount + summary.AF.noCount + summary.AF.naCount), name: 'AF Unknown'});
                }
                if(summary.CB) {
                    data.push('Crops Base');
                    childData.push({value: summary.CB.totalCount, name: 'Crops Base'});
                    subChildData.push({value: summary.CB.yesCount, name: 'CB Yes'});
                    subChildData.push({value: summary.CB.noCount, name: 'CB No'});
                    subChildData.push({value: summary.CB.naCount, name: 'CB N/A'});
                    subChildData.push({value: summary.CB.totalCount - (summary.CB.yesCount + summary.CB.noCount + summary.CB.naCount), name: 'CB Unknown'});
                }
                if(summary.FV) {
                    data.push('Fruits & Vegetables');
                    childData.push({value: summary.FV.totalCount, name: 'Fruits & Vegetables'});
                    subChildData.push({value: summary.FV.yesCount, name: 'FV Yes'});
                    subChildData.push({value: summary.FV.noCount, name: 'FV No'});
                    subChildData.push({value: summary.FV.naCount, name: 'FV N/A'});
                    subChildData.push({value: summary.FV.totalCount - (summary.FV.yesCount + summary.FV.noCount + summary.FV.naCount), name: 'FV Unknown'});
                }
                if(summary.CUSTOM) {
                    data.push('Custom');
                    childData.push({value: summary.CUSTOM.totalCount, name: 'Custom'});
                    subChildData.push({value: summary.CUSTOM.yesCount, name: 'Custom Yes'});
                    subChildData.push({value: summary.CUSTOM.noCount, name: 'Custom No'});
                    subChildData.push({value: summary.CUSTOM.naCount, name: 'Custom N/A'});
                    subChildData.push({value: summary.CUSTOM.totalCount - (summary.CUSTOM.yesCount + summary.CUSTOM.noCount + summary.CUSTOM.naCount), name: 'Custom Unknown'});
                }

                this.options.legend.data    = data;
                this.options.series[0].data = parentData;
                this.options.series[1].data = childData;
                this.options.series[2].data = subChildData;

                this.options = JSON.parse(JSON.stringify(this.options));
            }
        }
    }
</script>

<style scoped>
    .echarts {
        width: 100%;
        height: 400px;
    }

    .icon {
        min-width: 60px;
    }
</style>